/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.card-extensions.card-config.background-color-field.title': 'Hintergrundfarbe',
  'company-hub.card-extensions.card-config.text-color-field.title': 'Textfarbe',
  'company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder': 'Ihrer Karte einen Titel geben',
  'company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder': 'Ihrer Karte einen Titel geben',
  'company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder':
    'Ihrer Karte einen Titel geben',
  'company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder':
    'Ihrer Karte einen Titel geben',
  'company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder': 'Ihrer Karte einen Titel geben',
  'company-hub.cards-extension.ai-disclaimer.disclaimer-message': 'KI-generierter Inhalt',
  'company-hub.cards-extension.autoscroll-wrapper.pause': 'Anhalten',
  'company-hub.cards-extension.autoscroll-wrapper.play': 'Abspielen',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label': 'Symbol',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label':
    'Statistik zu sozialen Medien',
  'company-hub.cards-extension.card.background.color': 'Hintergrundfarbe',
  'company-hub.cards-extension.card.color-contrast.fail':
    'Ihre Text- und Hintergrundfarben sind mit Blick auf die Lesbarkeit nicht gut geeignet.',
  'company-hub.cards-extension.card.color-contrast.success':
    'Der Text und die Hintergrundfarben sind mit Blick auf die Lesbarkeit gut geeignet.',
  'company-hub.cards-extension.card.text.color': 'Textfarbe',
  'company-hub.cards-extension.cards.config-panel.border.color': 'Rahmenfarbe',
  'company-hub.cards-extension.cards.hub-element.description': 'Präsentieren Sie Links, Bilder und mehr.',
  'company-hub.cards-extension.cards.hub-element.title': 'Karten',
  'company-hub.cards-extension.config-panel.link.field.label': 'Verknüpfen',
  'company-hub.cards-extension.config-panel.render-variant.dynamic': '<p>Dynamisch</p>',
  'company-hub.cards-extension.config-panel.render-variant.dynamic.description':
    'Verwenden Sie <strong>dynamische</strong> Karten, um Filter zu erstellen, die sofort einen Kartensatz generieren, der sich automatisch aktualisiert.',
  'company-hub.cards-extension.config-panel.render-variant.manual': '<p>Manuell</p>',
  'company-hub.cards-extension.config-panel.render-variant.manual.description':
    'Verwenden Sie <strong>manuelle</strong> Karten, um Ihrem Hub bestimmte Links, Texte oder Bilder hinzuzufügen.',
  'company-hub.cards-extension.description.field.label': 'Beschreibung',
  'company-hub.cards-extension.dynamic-card-empty-state.no-filter-title': 'Zum Befüllen der Karten Filter hinzufügen',
  'company-hub.cards-extension.dynamic-card-empty-state.no-results-title':
    'Hier gibt es noch nichts zu sehen. Schauen Sie bald wieder vorbei.',
  'company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title': 'Anzeigeoptionen',
  'company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list': 'Karten hinzufügen',
  'company-hub.cards-extension.link-cards-config-panel.cards.style.general.title': 'Allgemein',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description':
    'Die Bildgröße ist auf allen Karten gleich.',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label':
    'Feste Bildhöhe',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description':
    'Die Bildgröße richtet sich nach der Textmenge.',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label':
    'Flexible Bildhöhe',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title': 'Layouts',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description':
    'Präsentieren Sie Links, Bilder und mehr. {link}',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link':
    'Präsentieren Sie Links, Bilder und mehr.',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description.link': 'Erfahren Sie mehr über Karten.',
  'company-hub.cards-extension.link-cards-config-panel.content-tab.label': 'Inhalt',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label': 'Groß',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label': 'Mittel',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label': 'Klein',
  'company-hub.cards-extension.link-cards-config-panel.size-text-label': 'Größe',
  'company-hub.cards-extension.link-cards-config-panel.styles-tab.label': 'Stile',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label': 'Automatisches Scrollen',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content':
    'Karten, die nicht auf den Bildschirm passen, beginnen zu scrollen, wenn Sie den Bearbeitungsmodus verlassen',
  'company-hub.cards-extension.link-cards-config-panel.styles.display-as-label': 'Anzeigen als',
  'company-hub.cards-extension.link-cards-config-panel.styles.padding-label': 'Abstand',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-description':
    'Karten werden innerhalb derselben Zeile gescrollt.',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-label': 'Zeile',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-description':
    'Bei Karten erfolgt ein Umbruch in eine neue Zeile.',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-label': 'Gestapelt',
  'company-hub.cards-extension.link-cards-config-panel.title-text-label': 'Karten',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2': 'Beschreibung',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label': 'Besitzer anzeigen',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2': 'Inhaltsbesitzer',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.info-icon-label':
    'Wählen Sie aus, welchen Confluence-Benutzergruppen Ihre Karten angezeigt werden',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2': 'Stichwort',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label': 'Neu',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2': 'Neu',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label':
    'Letzte Aktualisierung anzeigen',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2':
    'Letzte Aktualisierung',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label': 'Zielgruppe auswählen',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2': 'Zielgruppe',
  'company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards': 'Dynamische Karten erstellen',
  'company-hub.cards-extension.link-cards-content.card-components.card-count-label': 'Anzahl der Karten',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button':
    'Abbrechen',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button':
    'Alle Filter löschen',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button':
    'Bestätigen',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header':
    'Dynamische Karten erstellen',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext':
    'Erstellen Sie einen benutzerdefinierten Satz automatisch ausgefüllter Karten, die die neuesten Informationen anzeigen. Verwenden Sie Filter, um Karteninhalte nach Stichwort, Bereich, Besitzer und mehr auszuwählen.',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header':
    'Noch keine dynamischen Karten vorhanden',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description':
    'Der Inhalt existiert nicht oder hat sich möglicherweise geändert, nachdem dieser Link hinzugefügt wurde.',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header':
    'Dieser Inhalt kann nicht angezeigt werden',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.button.label':
    'Zugriff anfordern',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.description':
    'Bitte senden Sie eine Zugriffsanfrage oder versuchen Sie, die Vorschau über ein anderes Konto anzusehen.',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.header':
    'Inhalt mit Beschränkungen',
  'company-hub.cards-extension.link-cards-content.card-components.view-current-filters': 'Aktuelle Filter anzeigen',
  'company-hub.cards-extension.manifest.macro-description': 'Links als Karten anzeigen',
  'company-hub.cards-extension.manifest.macro-title': 'Karten',
  'company-hub.cards-extension.recommended.field.label': '(Empfohlen)',
  'company-hub.cards-extension.row-orientation.next': 'Weiter',
  'company-hub.cards-extension.row-orientation.previous': 'Zurück',
  'company-hub.cards-extension.smart-card.empty-state.placeholder-title': 'Titel hinzufügen',
  'company-hub.cards-extension.smart-card.no-results-title':
    'Hier gibt es noch nichts zu sehen. Schauen Sie bald wieder vorbei.',
  'company-hub.cards-extension.title.field.label': 'Titel',
};
